module.exports = __webpack_public_path__ + "img/falco-min.6230e880.png";